export const SAMPLEDATA_UPDATE = 'SAMPLEDATA_UPDATE';
export const SAMPLEDATA_DELETE = 'SAMPLEDATA_DELETE';

export interface CountryDto {
    code: string;
    description: string;
}

export interface PopulationSizeDto {
    code: string;
    description: string;
}

export interface CityTownDto {
    code: string;
    description: string;
    countryCode: string;
    populationSizeCode: string;
}

const initialCountryList: CountryDto[] = [
    { code: "UK", description: "United Kingdom" },
    { code: "USA", description: "United States" },
    { code: "SA", description: "South Africa" }
]

const initialPopulationSizeList: PopulationSizeDto[] = [
    { code: "LG", description: "Large" },
    { code: "MD", description: "Medium" },
    { code: "SM", description: "Small" }
]

const initialCityTownList: CityTownDto[] = [
    { code: "LND", description: "London", countryCode: "UK", populationSizeCode: "LG" },
    { code: "MCH", description: "Manchester", countryCode: "UK", populationSizeCode: "MD" },
    { code: "MK", description: "Milton Keynes", countryCode: "UK", populationSizeCode: "SM" },
    { code: "NOT", description: "Nottingham", countryCode: "UK", populationSizeCode: "SM" },
    { code: "NY", description: "New York", countryCode: "USA", populationSizeCode: "LG" },
    { code: "LA", description: "Los Angeles", countryCode: "USA", populationSizeCode: "LG" },
    { code: "BOS", description: "Boston", countryCode: "USA", populationSizeCode: "MD" },
    { code: "JHB", description: "Johannesburg", countryCode: "SA", populationSizeCode: "LG" },
    { code: "CT", description: "Cape Town", countryCode: "SA", populationSizeCode: "MD" },
    { code: "DRN", description: "Durban", countryCode: "SA", populationSizeCode: "SM" },
    { code: "PTA", description: "Pretoria", countryCode: "SA", populationSizeCode: "LG" }
]

export interface SampleDataModel {
    countries: CountryDto[];
    populationSizes: PopulationSizeDto[];
    cityTowns: CityTownDto[];
}

export const initialState: SampleDataModel = {
    countries: initialCountryList,
    populationSizes: initialPopulationSizeList,
    cityTowns: sortedCityTowns(initialCityTownList)
};

export const reducer = (
    state = initialState,
    action: { type: string; payload: CityTownDto & CityTownDto[] }
): SampleDataModel => {
    switch (action.type) {
        case SAMPLEDATA_UPDATE:
            {
                let cityTowns = state.cityTowns;
                const cityTown = cityTowns.find(ct => ct.code === action.payload.code);
                if (cityTown) {
                    cityTowns = cityTowns.filter(ct => ct.code !== cityTown.code);
                }
                cityTowns = [...cityTowns, action.payload];

                return {
                    ...state,
                    cityTowns: sortedCityTowns(cityTowns)
                };
            }
        case SAMPLEDATA_DELETE:
            {
                const newCityTownList = state.cityTowns.filter(ct => !action.payload.some(d => ct.code === d.code));

                return {
                    ...state,
                    cityTowns: sortedCityTowns(newCityTownList)
                };
            }
        default:
            return initialState;
    }
};

function sortedCityTowns(cityTowns: CityTownDto[]) {
    return cityTowns.sort((a, b) => (a.description.toLowerCase() < b.description.toLowerCase()) ? -1 : 1);
}
